module.exports = __webpack_public_path__ + "img/qimeng.c4323983.jpg";